var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicroNotAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_15422_74736)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#667085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3647 38.2168V31.8168C37.3647 29.4068 35.411 27.4531 33.0011 27.4531C31.2882 27.4531 29.8058 28.4401 29.0915 29.8763M33.0011 52.1804V56.544M27.1829 56.544H38.8192M19.9102 28.9077L46.092 55.0895M22.8199 39.0895C22.8199 39.0895 20.6383 52.1804 33.0593 52.1804C36.6519 52.1804 39.0132 51.0853 40.5549 49.5285M43.229 43.4531C43.5269 41.0497 43.1828 39.0895 43.1828 39.0895M37.3647 33.2713H34.4556M33.0011 46.3622C30.5911 46.3622 28.6374 44.4085 28.6374 41.9986V37.6349L36.0885 45.0823C35.2987 45.873 34.207 46.3622 33.0011 46.3622Z",
    stroke: "white",
    strokeWidth: 2.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.4538,
    y: 2.00071,
    width: 30.5455,
    height: 30.5455,
    rx: 15.2727,
    fill: "#F24822"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.4538,
    y: 2.00071,
    width: 30.5455,
    height: 30.5455,
    rx: 15.2727,
    stroke: "#F0FBFF",
    strokeWidth: 1.45455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8027 20.827L55.8555 8.54688H59.5957L58.6485 20.827H56.8027ZM56.0255 26.0014V22.56H59.4257V26.0014H56.0255Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_15422_74736",
    x: 0,
    y: 0.273438,
    width: 76.7266,
    height: 76.7266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2125 0 0 0 0 0.2125 0 0 0 0 0.2125 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15422_74736"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15422_74736",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroNotAccess);
export default __webpack_public_path__ + "static/media/micro-not-access.cd6f20ea38fefa52ba7c32e030df16d7.svg";
export { ForwardRef as ReactComponent };